import { Fragment, useCallback, useEffect, useState } from "react";
import { MdSyncProblem } from "react-icons/md";
import Layout from "../../components/Layout";
import { api } from "../../services/api";

export default function ConflitosSincronizacao() {
  const [carregando, setCarregando] = useState(true);
  const [conflitos, setConflitos] = useState([]);
  const [erro, setErro] = useState("");
  const [detalheAberto, setDetalheAberto] = useState(null);

  const carregarConflitos = useCallback(async () => {
    try {
      setCarregando(true);
      setErro("");
      const response = await api.get("/api/sync/conflitos/");
      const dados = response.data.results || response.data;
      setConflitos(Array.isArray(dados) ? dados : []);
    } catch (error) {
      console.error("Erro ao carregar conflitos de sincronização:", error);
      setErro("Erro ao carregar o log de conflitos. Verifique sua conexão.");
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => {
    carregarConflitos();
  }, [carregarConflitos]);

  const formatarData = (data) =>
    data ? new Date(data).toLocaleString("pt-BR") : "—";

  return (
    <Layout>
      <div className="p-6 font-medium max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
            Conflitos de Sincronização <MdSyncProblem size={34} />
          </h2>
          <button
            onClick={carregarConflitos}
            className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg transition-colors"
          >
            Atualizar
          </button>
        </div>

        <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-800">
          Esta tela mostra edições feitas offline que perderam para outra edição mais
          recente do mesmo registro (regra: última edição vence). Nenhum dado foi
          perdido de forma definitiva — a versão que perdeu fica registrada aqui, com
          o conteúdo completo que não foi salvo, para conferência manual se necessário.
        </div>

        {erro && (
          <div className="mb-4 p-3 rounded-lg bg-red-100 text-red-700 border border-red-200">
            {erro}
          </div>
        )}

        <div className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
          <div className="p-4 border-b border-gray-200 bg-gray-50">
            <p className="text-gray-600">
              {conflitos.length} conflito(s) registrado(s)
            </p>
          </div>

          {carregando ? (
            <div className="p-8 text-center text-gray-500">Carregando...</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="p-3 text-left text-sm font-semibold text-gray-700">Data</th>
                    <th className="p-3 text-left text-sm font-semibold text-gray-700">Modelo</th>
                    <th className="p-3 text-left text-sm font-semibold text-gray-700">Registro</th>
                    <th className="p-3 text-left text-sm font-semibold text-gray-700">Usuário</th>
                    <th className="p-3 text-left text-sm font-semibold text-gray-700">Editado offline em</th>
                    <th className="p-3 text-left text-sm font-semibold text-gray-700">Detalhes</th>
                  </tr>
                </thead>
                <tbody>
                  {conflitos.map((c) => (
                    <Fragment key={c.id}>
                      <tr className="border-t border-gray-200 hover:bg-gray-50 transition-colors">
                        <td className="p-3 text-sm">{formatarData(c.criado_em)}</td>
                        <td className="p-3 text-sm font-mono">{c.modelo}</td>
                        <td className="p-3 text-sm font-mono">{c.object_id ?? c.object_uuid}</td>
                        <td className="p-3 text-sm">{c.usuario_nome || "—"}</td>
                        <td className="p-3 text-sm">{formatarData(c.client_edited_at)}</td>
                        <td className="p-3 text-sm">
                          <button
                            onClick={() =>
                              setDetalheAberto(detalheAberto === c.id ? null : c.id)
                            }
                            className="text-blue-600 hover:text-blue-800 underline"
                          >
                            {detalheAberto === c.id ? "Ocultar" : "Ver payload perdido"}
                          </button>
                        </td>
                      </tr>
                      {detalheAberto === c.id && (
                        <tr className="border-t border-gray-100 bg-gray-50">
                          <td colSpan="6" className="p-3">
                            <pre className="text-xs bg-white border border-gray-200 rounded p-3 overflow-x-auto">
                              {JSON.stringify(c.payload_perdido, null, 2)}
                            </pre>
                          </td>
                        </tr>
                      )}
                    </Fragment>
                  ))}

                  {conflitos.length === 0 && (
                    <tr>
                      <td colSpan="6" className="p-8 text-center text-gray-500">
                        Nenhum conflito registrado até agora.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
}
